// 首页section4
var viewMoneTab4 = document.querySelector('.collection-tabs-view-more-link4')

var link4 = viewMoneTab4.querySelectorAll('.collection-tabs__list-link4')
var button4 = viewMoneTab4.querySelectorAll('.tabs-loading-more-button4')

button4.forEach((b,i) => {
    if (i > 0) {
        b.classList.add('dis_none')
    }

})

link4.forEach((l ,i) => {
    l.addEventListener('click', () => {
        // console.log('打印哒哒哒哒哒哒4' + i);
        button1.forEach((b,index) => {
            if (index === i) {
                b.classList.remove('dis_none');
            } else {
                b.classList.add('dis_none');
            }
        
        })
    })
})

// // 首页section5
// var viewMoneTab5 = document.querySelector('.collection-tabs-view-more-link5')

// var link5 = viewMoneTab5.querySelectorAll('.collection-tabs__list-link5')
// var button5 = viewMoneTab5.querySelectorAll('.tabs-loading-more-button5')

// button5.forEach((b,i) => {
//     if (i > 0) {
//         b.classList.add('dis_none')
//     }

// })

// link5.forEach((l ,i) => {
//     l.addEventListener('click', () => {
//         // console.log('打印哒哒哒哒哒哒5' + i);
//         button1.forEach((b,index) => {
//             if (index === i) {
//                 b.classList.remove('dis_none');
//             } else {
//                 b.classList.add('dis_none');
//             }
        
//         })
//     })
// })

